import Style from "./MaterialDetailsStyle";
import Spinner from "../../shared/Spinner/Spinner";
import api from "../../services/api";
import AuthContext from "../../contexts/authContext";
import * as utils from "../../utils";
import { useContext, useEffect, useState } from "react";
import { AxiosRequestConfig } from "axios";
import PageTitle from "../../components/PageTitle";
import { InputImage } from "../../components/InputImage/InputImage";
import InfoModal from "../../shared/Bootstrap/InfoModal";
import TwoButtonsModal from "../../shared/Bootstrap/TwoButtonsModal";
import { ProgressBar } from "react-bootstrap";
import { GetFileFromURL } from "../../utils";


///TODO: Trocar para saber se é super user
const ownerCompanyId = 1;

export default function MaterialDetails(props) {

  const { userData } = useContext(AuthContext);
  const [name, setName] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [supplier, setSupplier] = useState("");
  const [supplierCode, setSupplierCode] = useState("");
  const [category, setCategory] = useState("");
  const [fixedPrice, setFixedPrice] = useState("R$ 0,00");
  const [squareMeterPrice, setSquareMeterPrice] = useState("R$ 0,00");
  const [laborSquareMeterPrice, setLaborSquareMeterPrice] = useState("R$ 0,00");
  const [hasArt, setHasArt] = useState(false);
  const [materialType, setMaterialType] = useState("1");
  const [uvX, setUvX] = useState(1);
  const [uvY, setUvY] = useState(1);

  const [companyId, setCompanyId] = useState(0);
  const [albedoUrl, setAlbedoUrl] = useState("");
  const [selectedFile, setSelectedFile] = useState({} as File);

  const [uploadingFile, setUploadingFile] = useState(false);
  const [uploadPercentage, setUploadPercentage] = useState(0);

  const [deleteImage, setDeleteImage] = useState(false);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const materialId = parseInt(props.match?.params?.materialId) || 0;
  const creatingNew = materialId <= 0;

  const disabled = loading || (userData.companyId !== companyId && userData.companyId !== ownerCompanyId && !creatingNew);

  useEffect(() => {
    if (!creatingNew)
      LoadMaterial();

  }, []);

  async function LoadMaterial() {
    try {
      const result = await api.get(`materials/${materialId}`);
      if (result.data.success) {
        const material = result.data.material;
        setName(material.name);
        setDisplayName(material.displayName);
        setSupplier(material.supplierName || "");
        setSupplierCode(material.supplierCode);
        setCategory(material.category);
        setFixedPrice(utils.CentsToHuman(material.fixedPrice));
        setSquareMeterPrice(utils.CentsToHuman(material.squareMeterPrice));
        setLaborSquareMeterPrice(utils.CentsToHuman(material.laborSquareMeterPrice));
        setHasArt(material.hasArt > 0 ? true : false);
        setMaterialType(material.materialType.toString());
        setCompanyId(material.companyId);
        setAlbedoUrl(material.albedoUrl);
        setUvX(material.uvX || 1);
        setUvY(material.uvY || 1);
      }
      else
        console.error("Não pode pegar dados do material: ", result.data);
    }
    catch (error: any) {
      console.error("Erro pegando material: ", error);
      setErrorMessage(error.response?.data?.message || "Não foi possível carregar material");
    }
    finally {
      setLoading(false);
    }
  }

  async function OnSubmit() {
    setLoading(true);
    onClosePopup();
    try {
      const options: AxiosRequestConfig = {};
      const formData = new FormData();
      if (selectedFile.name && !deleteImage) {
        formData.append("albedo", selectedFile, selectedFile.name);
        options.onUploadProgress = progressEvent => {
          const { loaded, total } = progressEvent;
          const percentage = Math.floor(loaded * 100 / total);
          setUploadPercentage(percentage);
        }
      }
      else {
        formData.append("albedoUrl", albedoUrl);
      }
      formData.append("name", name);
      formData.append("companyId", userData.companyId.toString());
      formData.append("displayName", displayName);
      formData.append("supplierName", supplier);
      formData.append("supplierCode", supplierCode);
      formData.append("category", category);
      formData.append("fixedPrice", utils.CurrencyToCents(fixedPrice).toString());
      formData.append("squareMeterPrice", utils.CurrencyToCents(squareMeterPrice).toString());
      formData.append("laborSquareMeterPrice", utils.CurrencyToCents(laborSquareMeterPrice).toString());
      formData.append("hasArt", hasArt.toString());
      formData.append("uvX", uvX.toString());
      formData.append("uvY", uvY.toString());
      formData.append("materialType", materialType);
      if (!creatingNew) {
        formData.append("deleteImage", deleteImage.toString());
      }
      setUploadingFile(true);

      await (creatingNew
        ? api.post("/materials", formData, options)
        : api.put(`/materials/${materialId}`, formData, options));
      LoadMaterial();
      setUploadingFile(false);
      if (creatingNew) {
        goBack();
      } else {
        setAlbedoUrl("");
        setShowSuccessPopup(true);
      }
    }
    catch (error: any) {
      setUploadingFile(false);
      setErrorMessage(error?.response?.data?.message);
      console.error(error);
    } finally {
      setLoading(false);
      onClosePopup();
    }
  }

  function ChangeFileSelected(event) {
    setAlbedoUrl("");
    setSelectedFile(event.target.files[0]);
    setDeleteImage(false);
  };

  function GetImageUrl(): string {
    return GetFileFromURL(albedoUrl, `${process.env.REACT_APP_BASE_URL}/materials/${materialId}/image`);
  }

  function goBack() {
    props.history.goBack();
  }

  function ShowSuccessPopup() {
    return (
      <InfoModal
        show={showSuccessPopup}
        onHide={() => setShowSuccessPopup(false)}
        loading={false}
        title="Material editado com sucesso!"
        body="Suas edições foram salvas com sucesso!"
        primaryText="OK"
        primaryOnClick={() => setShowSuccessPopup(false)}
        primaryDisabled={false}
      />
    )
  }
  function onOpenPopUp() {
    setShowPopup(true);
  }

  function onClosePopup() {
    setShowPopup(false);
  }

  return (
    <Style>
      {ShowSuccessPopup()}
      <PageTitle title="Detalhes do Material" />
      <TwoButtonsModal
        show={showPopup}
        onHide={onClosePopup}
        loading={false}
        title={creatingNew ? "Cadastrar material" : "Editar material"}
        body={"Você tem certeza que deseja " + (creatingNew ? "cadastrar este material?" : "editar este material?")}
        secondaryText="Fechar"
        secondaryOnClick={onClosePopup}
        secondaryDisabled={loading}
        primaryText="Confirmar"
        primaryOnClick={OnSubmit}
        primaryDisabled={loading}
      />
      <div className="materials">
        <div>
          <button onClick={() => goBack()} className="btn btn-secondary">Voltar</button>
        </div>
        <Spinner spinning={loading} />
        {errorMessage && <p className="alert">Erro: {errorMessage}</p>}
        <main>
          <div className="panel">
            <form className="main-form" onSubmit={(e) => { e.preventDefault() }}>
              <div>
                <h2>{creatingNew ? "Criação" : "Edição"} de Material</h2>
              </div>
              <div>
                <label>Nome interno:</label>
                <input
                  autoComplete="material-name"
                  disabled={!creatingNew}
                  value={name}
                  onChange={e => setName(e.target.value)}
                />
              </div>
              <div>
                <label>Nome de Exibição:</label>
                <input
                  autoComplete="material-display-name"
                  disabled={disabled}
                  value={displayName}
                  onChange={e => setDisplayName(e.target.value)} />
              </div>

              <div>
                <label>Fornecedor:</label>
                <input
                  autoComplete="supplier"
                  disabled={disabled}
                  value={supplier}
                  onChange={e => setSupplier(e.target.value)} />
              </div>

              <div>
                <label>Código no Fornecedor:</label>
                <input
                  autoComplete="supplier-code"
                  disabled={disabled}
                  value={supplierCode}
                  onChange={e => setSupplierCode(e.target.value)} />
              </div>

              <div>
                <label>Categoria:</label>
                <input
                  autoComplete="material-category"
                  disabled={disabled}
                  value={category}
                  onChange={e => setCategory(e.target.value)} />
              </div>

              <div>
                <label>Preço Base:</label>
                <input
                  autoComplete="off"
                  disabled={disabled}
                  value={fixedPrice}
                  onChange={e => setFixedPrice(utils.MaskPrice(e.target.value))} />
              </div>

              <div>
                <label>Preço m²:</label>
                <input
                  autoComplete="off"
                  disabled={disabled}
                  value={squareMeterPrice}
                  onChange={e => setSquareMeterPrice(utils.MaskPrice(e.target.value))} />
              </div>

              <div>
                <label>Mão de obra m²:</label>
                <input
                  autoComplete="off"
                  disabled={disabled}
                  value={laborSquareMeterPrice}
                  onChange={e => setLaborSquareMeterPrice(utils.MaskPrice(e.target.value))} />
              </div>

              <div>
                <label>ART:</label>
                <input
                  type="checkbox"
                  disabled={disabled}
                  checked={hasArt}
                  onChange={e => setHasArt(e.target.checked)} />
              </div>


              <div>
                <label>UV X:</label>
                <input
                  type="number"
                  step="0.1"
                  autoComplete="off"
                  disabled={disabled}
                  value={uvX}
                  onChange={e => setUvX(parseFloat(e.target.value))} />
              </div>
              <div>
                <label>UV Y:</label>
                <input
                  type="number"
                  step="0.1"
                  autoComplete="off"
                  disabled={disabled}
                  value={uvY}
                  onChange={e => setUvY(parseFloat(e.target.value))} />
              </div>
              <div>
                <label>Url:</label>
                <input
                  type="url"
                  autoComplete="off"
                  disabled={disabled || Boolean(selectedFile?.name)}
                  value={albedoUrl}
                  onChange={e => setAlbedoUrl(e.target.value)} />
              </div>
              <div>
                <label>Imagem:</label>
                <InputImage
                  id="file"
                  name="file"
                  disabled={disabled || uploadingFile}
                  label=""
                  alt="Imagem do produto"
                  acceptedMimeTypes="image/png, image/jpeg"
                  imageUrl={GetImageUrl()}
                  OnChange={ChangeFileSelected}
                  OnRemove={() => setDeleteImage(true)}
                  image={selectedFile}
                />
              </div>

              {(uploadingFile) &&
                <div>
                  <label htmlFor="file">Progresso do Upload:</label>
                  <ProgressBar variant="success" now={uploadPercentage} label={`${uploadPercentage}%`} />
                </div>
              }

              <button
                className="btn btn-success btn-lg"
                type="button"
                disabled={disabled || uploadingFile || selectedFile === undefined}
                onClick={e => {
                  e.preventDefault();
                  onOpenPopUp();
                }}>{creatingNew ?
                  "Adicionar" :
                  "Editar"}
              </button>
            </form>
          </div>
          <div className="panel">
            <form>
              <div>
                <h1>Materiais</h1>
              </div>
              <div className="material-option">
                <img src={process.env.PUBLIC_URL + '/images/material_reflective.jpg'} alt="Reflexivo" />
                <input
                  type="radio"
                  name="material"
                  id="reflective"
                  value="1"
                  onChange={e => setMaterialType(e.target.value)}
                  checked={materialType === "1"}
                />
                <label htmlFor="reflective">Material Reflexivo</label>
              </div>
              <div className="material-option">
                <img src={process.env.PUBLIC_URL + '/images/material_opaque.jpg'} alt="Opaco" />
                <input type="radio"
                  name="material"
                  id="opaque"
                  value="2"
                  onChange={e => setMaterialType(e.target.value)}
                  checked={materialType === "2"} />
                <label htmlFor="frosted">Material Opaco</label>
              </div>
              <div className="material-option">
                <img src={process.env.PUBLIC_URL + '/images/material_plastic.jpg'} alt="Plástico" />
                <input type="radio"
                  name="material"
                  id="plastic"
                  value="3"
                  onChange={e => setMaterialType(e.target.value)}
                  checked={materialType === "3"} />
                <label htmlFor="plastic">Material Plástico</label>
              </div>
              <div className="material-option">
                <img src={process.env.PUBLIC_URL + '/images/material_transparent.jpg'} alt="Transparente" />
                <input type="radio"
                  name="material"
                  id="transparent"
                  value="4"
                  onChange={e => setMaterialType(e.target.value)}
                  checked={materialType === "4"} />
                <label htmlFor="plastic">Material Transparente</label>
              </div>
            </form>
          </div>
        </main>
        <div>
        </div>
      </div>
    </Style >
  );
}
